import { Fragment, ReactElement } from 'react';
import ResearchCivilUnionNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCivilUnionNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCivilUnionNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchCivilUnionNotificationCivilStatusPage.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionNotificationCivilStatusPage;
